// extracted by mini-css-extract-plugin
export default {"container":"fullWidth_container__Km7jV"};